import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MemberForm from '../../components/ui/MemberForm';
import { createMember, syncMemberGroups, sanitizePayload } from '../../hooks/useMembers';

export default function AddMemberPage() {
  const navigate  = useNavigate();
  const [loading, setLoading] = useState(false);

  async function handleSubmit(data, groupIds) {
    setLoading(true);
    // sanitizePayload converts empty strings to null for dates & UUIDs
    const cleanData = sanitizePayload(data);
    const member = await createMember({ ...cleanData, status: 'active' });
    if (member) {
      await syncMemberGroups(member.id, groupIds);
      navigate('/admin/members');
    }
    setLoading(false);
  }

  return (
    <div>
      <div className="mb-4">
        <h1 style={{ fontSize: 20, fontWeight: 800 }}>➕ Add Member</h1>
        <div style={{ fontSize: 13, color: 'var(--text3)', marginTop: 2 }}>
          Assisted registration for members who need help. Admin-added members are approved immediately.
        </div>
      </div>
      <div className="alert alert-info mb-4">
        Fill this form to add Members . They will be set as <strong>Active</strong> immediately.
      </div>
      <div className="card">
        <div className="card-pad">
          <MemberForm onSubmit={handleSubmit} loading={loading} submitLabel="➕ Add Member" />
        </div>
      </div>
    </div>
  );
}